import { Divider, Paper, Typography, makeStyles } from '@material-ui/core';
import { inject, observer } from 'mobx-react';
import { withSnackbar } from 'notistack';
import React from 'react';

const useStyles = makeStyles(theme => ({
  sectionTitle: {
    fontWeight: 'bold',
    color: theme.palette.primary.main,
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    paddingBottom: theme.spacing(1)
  },
  paper: {
    padding: theme.spacing(2),
    marginBottom: theme.spacing(3)
  },
  divider: {
    marginBottom: theme.spacing(2)
  }
}));

const ContainerDataView = ({ icon, title, children }) => {
  const classes = useStyles();

  return (
    <Paper variant="outlined" className={classes.paper}>
      <Typography className={classes.sectionTitle} gutterBottom>
        {icon} {title}
      </Typography>
      <Divider light variant="fullWidth" className={classes.divider} />
      {children}
    </Paper>
  );
};

export default inject('datos')(observer(withSnackbar(ContainerDataView)));
